//============================
//# ilsysisync_invitem DTO
//# Számlatétel köztes tábla — kiegészítve a felületi állapot-mezőkkel és számolt mezőkkel
//============================
import IfaceSyncInvoiceItem, { IfaceSyncInvoiceItemDefaultProps } from "./IfaceSyncInvoiceItem";

export default interface IfaceSyncInvoiceItemDTO extends IfaceSyncInvoiceItem {
    /** Szerkesztés alatt */
    inEdit: boolean;
    /** Sor lenyitható részletek master toggle */
    showDetails: boolean;
    /** Szinkron előzmények megjelenítése (showDetails-szel együtt) */
    showHistory: boolean;
    /** Betöltött előzmény rekordok */
    history: IfaceSyncInvoiceItemDTO[] | null;
    /** Utolsó szinkronizálás pontos ideje */
    updDateTime: Date;
    /** Utoljára módosító munkatárs neve */
    updUserName: string;
    /** Szinkron státusz megnevezése */
    syncStatusName: string;
    /** A külső áfakód kulcshoz tartozó K2D áfakulcs megnevezés (a szinkron szótárból mappelve) */
    taxName: string;
}

/** Áfakulcs megjelenítés a tétel felületeken: "(külső kód) K2D megnevezés" — mappelés nélkül csak a kód */
export function taxCodeAndName(item: IfaceSyncInvoiceItemDTO): string {
    if (!item.tax) return "";
    return item.taxName ? `(${item.tax}) ${item.taxName}` : item.tax;
}

export const IfaceSyncInvoiceItemDTODefaultProps: IfaceSyncInvoiceItemDTO = {
    ...IfaceSyncInvoiceItemDefaultProps,
    inEdit: false,
    showDetails: false,
    showHistory: false,
    history: null,
    updDateTime: new Date(),
    updUserName: "",
    syncStatusName: "",
    taxName: "",
}
